export * from "./MovieDetailCardWithPoster/index";
export * from "./MovieDetailCardWithVideo/index";
export { default as MovieDetailCard } from "./MovieDetailCard";
